namespace GeniuzPOS.QRreport {
    export interface QRywcSpec1404Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        CatCode: Serenity.LookupEditor;
    }

    export class QRywcSpec1404Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec1404';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec1404Form.init)  {
                QRywcSpec1404Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;

                Q.initFormType(QRywcSpec1404Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'CatCode', w0
                ]);
            }
        }
    }
}
